import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
/*
import {
  NbAuthComponent,
  NbLoginComponent,
  NbLogoutComponent,
  NbRegisterComponent,
  NbRequestPasswordComponent,
  NbResetPasswordComponent,
} from '@nebular/auth';
*/

import { LoginComponent } from './modules/auth/pages/login/login.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { BlankLayoutComponent } from './components/blank-layout/blank-layout.component';
import { DefaultLayoutComponent } from './components/default-layout/default-layout.component';


//import { ErrorGuard } from '@core/guards/error.guard';


const routes: Routes = [
  {
    path: 'auth',
    component: BlankLayoutComponent,
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      /*
      {
        path: 'register',
        component: NbRegisterComponent,
      },
      {
        path: 'logout',
        component: NbLogoutComponent,
      },
      {
        path: 'request-password',
        component: NbRequestPasswordComponent,
      },
      {
        path: 'reset-password',
        component: NbResetPasswordComponent,
      },
      */
    ],
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    canActivate: [AuthGuard],
  }

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
